import { createContext } from "react";

export type Language = "no" | "en";

export interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => Promise<void>;
  refreshLanguage: () => Promise<void>;
  t: (key: string, params?: Record<string, string | number>) => string;
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
